import PropTypes from 'prop-types';
import React from 'react';

import { ReactComponent as SVG } from '../svgs/potion.svg';

const PotionIcon = React.memo(({ background, size, style }) => (
  <div
    style={{
      background,
      borderRadius: '50%',
      color: '#FFFFFF',
      fontSize: 20,
      height: size,
      left: '-50%',
      lineHeight: '1.7em',
      marginLeft: -10,
      marginTop: -10,
      position: 'absolute',
      textAlign: 'center',
      top: '-50%',
      verticalAlign: 'middle',
      width: size,
      ...style,
    }}>
    <SVG />
  </div>
));

PotionIcon.defaultProps = {
  background: '#000000',
  size: 28,
  style: {},
};

PotionIcon.propTypes = {
  background: PropTypes.string,

  size: PropTypes.number,
  style: PropTypes.shape(),
};

export default PotionIcon;
